import React from 'react';
import { LoginProviderAccountCard } from './LoginProviderAccountCard/LoginProviderAccountCard.tsx';
import styles from './LoginProviderAccounts.module.scss';
/** List of login provider account cards. */ export const LoginProviderAccounts = ({ accounts })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.providerAccountsContainer
    }, accounts.map((account)=>/*#__PURE__*/ React.createElement(LoginProviderAccountCard, {
            key: account.title.key,
            account: account
        })));
